import React from "react";

export const DrawerContext = React.createContext(true);
